import { X } from 'lucide-react';
import type { FC, ReactNode } from 'react';
import { useAppStore } from '../../store/useAppStore';

type LegalModalFrameProps = {
  children: ReactNode;
};

export const LegalModalFrame: FC<LegalModalFrameProps> = ({ children }) => {
  const { closeModal } = useAppStore();

  return (
    <div className="fixed inset-0 z-modal-content flex items-end justify-center sm:items-center sm:p-4">
      <button
        type="button"
        className="absolute inset-0 bg-black/60"
        aria-label="Close"
        onClick={closeModal}
      />
      <div
        className="relative z-10 flex max-h-[90vh] w-full max-w-2xl flex-col overflow-hidden rounded-t-2xl border border-subtle/80 bg-surface shadow-2xl sm:max-h-[85vh] sm:rounded-2xl"
        role="dialog"
        aria-modal="true"
      >
        <div className="flex shrink-0 justify-end border-b border-subtle/60 px-2 py-1.5 sm:px-3">
          <button
            type="button"
            onClick={closeModal}
            className="rounded-full p-2 text-th-secondary transition hover:bg-overlay hover:text-th-primary"
            aria-label="Close"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain">{children}</div>
      </div>
    </div>
  );
};
